module.exports = __webpack_public_path__ + "static/media/_MIC2357.image.550ff030.png";